import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";

// Global error handler to prevent uncaught errors from showing red overlay
window.addEventListener('error', (event) => {
  // Always prevent default overlay in production
  event.preventDefault();
  event.stopPropagation();
  
  // Check for benign errors and suppress silently
  const msg = event.message || event.error?.message || '';
  if (event.error?.name === 'AbortError' || 
      msg.includes('abort') || 
      msg.includes('cancel') ||
      msg.includes('Share') ||
      msg.includes('ResizeObserver') ||
      msg.includes('Script error')) {
    return true;
  }
  
  // Warn instead of error to avoid alarming logs
  console.warn('[ErrorHandler] Caught error:', msg || event.error);
  return true;
});

// Handle unhandled promise rejections (e.g., navigator.share rejection)
window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason;
  
  // Always prevent the default browser behavior (error overlay, console error)
  event.preventDefault();
  
  // Check for known benign rejections and suppress silently
  const msg = reason?.message || reason?.toString?.() || '';
  const name = reason?.name || '';
  
  if (name === 'AbortError' || 
      name === 'NotAllowedError' ||
      name === 'SecurityError' ||
      msg.includes('abort') ||
      msg.includes('cancel') ||
      msg.includes('Share') ||
      msg.includes('clipboard') ||
      msg.includes('Clipboard') ||
      msg.includes('document is not focused') ||
      msg.includes('play()') ||
      msg.includes('user aborted') ||
      msg.includes('user denied') ||
      msg.includes('interrupted') ||
      msg.includes('The play() request') ||
      (name === 'TypeError' && msg.includes('Failed to fetch'))) {
    // Completely silent for known benign errors
    return;
  }

  // For all other rejections: warn (not error) to avoid alarming error logs
  console.warn('[ErrorHandler] Suppressed unhandled promise rejection:', reason);
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
